import { z } from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

import { missingTeethCountOptions } from './questions'

const dental_missing_teeth = (params: StepConfigParams) => {
  return {
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('number_of_missing_teeth')]: z.enum([
        '0',
        '1',
        '2',
        '3',
        '4',
      ]),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_missing_teeth.title',
        },
      },
      {
        type: 'text',
        emphasis: 'default',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_missing_teeth.body',
        },
      },
      {
        type: 'choice',
        variant: 'filled',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('number_of_missing_teeth'),
        options: [
          ...missingTeethCountOptions,
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_dental:steps.dental_missing_teeth.options.fourPlus',
            },
            value: '4',
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('number_of_missing_teeth'),
      valueToStepName: {
        '0': 'dental_periodontal_disease',
        '1': 'dental_periodontal_disease',
        '2': 'dental_periodontal_disease',
        '3': 'dental_periodontal_disease',
        '4': 'dental_missing_teeth_failure',
      },
    },
  } as const satisfies AnyStepConfiguration
}

export default dental_missing_teeth
